import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';

// 会社管理（本部adminのみ）。会社の一覧・追加・改名。
export default function CompanyManagement() {
  const [companies, setCompanies] = useState([]);
  const [name, setName] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);

  const load = () => api.getCompanies().then(setCompanies).catch((e) => setErr(e.message));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    setErr(''); setMsg('');
    if (!name.trim()) { setErr('会社名を入力してください'); return; }
    setSaving(true);
    try {
      await api.createCompany({ name: name.trim() });
      setMsg(`「${name.trim()}」を追加しました`);
      setName('');
      load();
    } catch (e) { setErr(e.message); }
    setSaving(false);
  };

  const rename = async (c) => {
    const next = window.prompt('新しい会社名', c.name);
    if (!next || !next.trim() || next.trim() === c.name) return;
    try { await api.updateCompany(c.id, { name: next.trim() }); load(); }
    catch (e) { setErr(e.message); }
  };

  const remove = async (c) => {
    setErr(''); setMsg('');
    if (!window.confirm(`「${c.name}」を削除します。よろしいですか？\n（所属する社員がいる場合は削除できません）`)) return;
    try {
      await api.deleteCompany(c.id);
      setMsg(`「${c.name}」を削除しました`);
      load();
    } catch (e) { setErr(e.message); }
  };

  const card = { background: 'var(--paper-sunk)', border: '1px solid var(--rule-strong)', borderRadius: 12, padding: 16 };
  const input = { width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid var(--rule-strong)', background: 'rgba(0,0,0,0.2)', color: 'var(--ink)', fontSize: 14 };

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: 'var(--s6) var(--s4) 120px' }}>
      <h2 style={{ fontSize: 20, fontWeight: 800, marginBottom: 4 }}>会社管理</h2>
      <p style={{ fontSize: 'var(--t-note)', color: 'var(--ink-soft)', marginBottom: 16 }}>傘下の会社を追加・改名できます（本部のみ）。</p>

      {err && <div style={{ background: 'var(--loss-bg)', color: 'var(--loss)', padding: 10, borderRadius: 8, marginBottom: 12, fontSize: 'var(--t-note)' }}>{err}</div>}
      {msg && <div style={{ background: 'var(--gain-bg)', color: 'var(--gain)', padding: 10, borderRadius: 8, marginBottom: 12, fontSize: 'var(--t-note)' }}>{msg}</div>}

      <form onSubmit={add} style={{ ...card, marginBottom: 16 }}>
        <div style={{ fontWeight: 700, marginBottom: 8 }}>会社を追加</div>
        <input style={input} value={name} onChange={(e) => setName(e.target.value)} placeholder="例：株式会社〇〇" />
        <button disabled={saving} style={{ marginTop: 12, width: '100%', padding: '10px', borderRadius: 8, border: 'none', background: 'var(--grad-primary)', color: '#fff', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>
          {saving ? '追加中...' : 'この会社を追加'}
        </button>
      </form>

      <div style={card}>
        <div style={{ fontWeight: 700, marginBottom: 8 }}>会社一覧</div>
        {companies.map((c) => (
          <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 0', borderBottom: '1px solid var(--rule-strong)' }}>
            <div style={{ flex: 1 }}>
              {c.name}{c.is_headquarters ? <span style={{ marginLeft: 6, fontSize: 'var(--t-note)', color: 'var(--mark)' }}>（本部）</span> : ''}
            </div>
            {!c.is_headquarters && (
              <>
                <button onClick={() => rename(c)} style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid var(--rule-strong)', background: 'transparent', color: 'var(--ink)', fontSize: 'var(--t-note)', cursor: 'pointer' }}>改名</button>
                <button onClick={() => remove(c)} style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid #6B3A36', background: 'transparent', color: 'var(--loss)', fontSize: 'var(--t-note)', cursor: 'pointer' }}>削除</button>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
